export const validatePasswordStrength = (password, passMatch)=>{
    /* eslint-disable no-useless-escape */
    const minLength = 8;
    const minDigits = 2;
    const minLowercase = 1;
    const minUppercase = 1;
    const minSpecialChars = 1;
    
    let pwd_errors = {
        "length":"",
        "digits":"",
        "lower":"",
        "upper":"",
        "special":"",
        "passmatch":""
    };
    if(passMatch) {
        pwd_errors["passmatch"]=true
    } else {
        pwd_errors["passmatch"]=""
    }
    if (password.length < minLength) {
        pwd_errors["length"]=""
    }else{
        pwd_errors["length"]=true
    }
    if (!/\d/.test(password) || (password.match(/\d/g) || []).length < minDigits) {
        pwd_errors["digits"]=""
    }else{
        pwd_errors["digits"]=true
    }
    if (!/[a-z]/.test(password) || (password.match(/[a-z]/g) || []).length < minLowercase) {
        pwd_errors["lower"]=""
    }else{
        pwd_errors["lower"]=true
    }
    if (!/[A-Z]/.test(password) || (password.match(/[A-Z]/g) || []).length < minUppercase) {
        pwd_errors["upper"]=""
    }else{
        pwd_errors["upper"]=true
    }
    if (!/[\~\`\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\\\/\"\;\:\'\<\>\,\.\?]/.test(password) || (password.match(/[\~\`\!\@\#\$\%\^\&\*\(\)\-\_\+\=\{\}\[\]\|\:\\\/\"\;\:\'\<\>\,\.\?]/g) || []).length < minSpecialChars) {
        pwd_errors["special"]=""
    }
    else{
        pwd_errors["special"]=true
    }
    return pwd_errors
}